<template>
  <div class="stock_add_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row">
      <div class="col-6 offset-3">
        <div style="padding:15px;width:100%;">
          <form @submit.prevent="updateStock" style="padding:15px;">
            <div class="form-group">
              <label for="model">Model *</label>
              <input
                :class="{
                  'is-invalid': $v.stockItem.model.$invalid && submit,
                  'is-valid': !$v.stockItem.model.$invalid && submit
                }"
                type="text"
                v-model="stockItem.model"
                class="form-control"
                id="model"
                name="model"
                aria-describedby="model_help"
                placeholder="Model i.e:IM20-18"
              />
              <div class="invalid-feedback">Please provide a Model Number</div>
            </div>

            <div class="form-group">
              <label for="qty">qty *</label>
              <input
                :class="{
                  'is-invalid': $v.stockItem.qty.$invalid && submit,
                  'is-valid': !$v.stockItem.qty.$invalid && submit
                }"
                type="text"
                v-model="stockItem.qty"
                class="form-control"
                id="qty"
                name="qty"
                aria-describedby="qty_help"
                placeholder="qty i.e:99"
              />
              <div class="invalid-feedback" v-if="!$v.stockItem.qty.required">
                Please provide a qty
              </div>
              <div class="invalid-feedback" v-if="!$v.stockItem.qty.numeric">
                Only numbers allowed
              </div>
            </div>

            <div class="form-group">
              <label for="name">Name *</label>
              <input
                :class="{
                  'is-invalid': $v.stockItem.productName.$invalid && submit,
                  'is-valid': !$v.stockItem.productName.$invalid && submit
                }"
                type="text"
                v-model="stockItem.productName"
                class="form-control"
                id="name"
                name="name"
                aria-describedby="model_help"
                placeholder="Name i.e:Noopept"
              />
              <div class="invalid-feedback">Please provide a name</div>
            </div>

            <div class="form-group">
              <label for="ingredients">Ingredients *</label>
              <textarea
                rows="7"
                cols="50"
                :class="{
                  'is-invalid': $v.stockItem.ingredients.$invalid && submit,
                  'is-valid': !$v.stockItem.ingredients.$invalid && submit
                }"
                v-model="stockItem.ingredients"
                class="form-control"
                id="ingredients"
                name="ingredients"
                aria-describedby="ingredients_help"
                placeholder="Ingredients i.e: pramiracetam, microcrystalline cellulose"
              ></textarea>
              <div class="invalid-feedback">Please provide ingredients</div>
            </div>

            <div class="form-group">
              <label for="stockable">stockable *</label>
              <select
                :class="{
                  'is-invalid': $v.stockItem.stockable.$invalid && submit,
                  'is-valid': !$v.stockItem.stockable.$invalid && submit
                }"
                v-model="stockItem.stockable"
                class="form-control"
                id="stockable"
                name="stockable"
              >
                <option value="yes">yes</option>
                <option value="no">no</option>
              </select>
            </div>

            <div class="form-group">
              <label for="supplier_problem">supplier problem *</label>
              <select
                :class="{
                  'is-invalid': $v.stockItem.supplier_problem.$invalid && submit,
                  'is-valid': !$v.stockItem.supplier_problem.$invalid && submit
                }"
                v-model="stockItem.supplier_problem"
                class="form-control"
                id="supplier_problem"
                name="supplier_problem"
              >
                <option value="yes">yes</option>
                <option value="no">no</option>
              </select>
            </div>

            <div class="form-group">
              <label>Expiry Date</label>
              <br />
              <div
                :class="{
                  'is-invalid': $v.stockItem.expiryDate.$invalid && submit,
                  'is-valid': !$v.stockItem.expiryDate.$invalid && submit
                }"
              >
                <date-picker
                  input-class="form-control"
                  @change="setExpiryDate"
                  @clear="setExpiryDate"
                  :value="stockItem.expiryDate"
                  input-name="shipping_date"
                  :first-day-of-week="1"
                  lang="en"
                  type="month"
                  format="YYYY-MM"
                ></date-picker>
                <div
                  class="invalid-feedback"
                  v-if="!$v.stockItem.expiryDate.required"
                >
                  Please provide a shipping date
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="weight">Weight (in gm)</label>
              <input
                :class="{
                  'is-invalid': $v.stockItem.weight.$invalid && submit,
                  'is-valid': !$v.stockItem.weight.$invalid && submit
                }"
                type="text"
                v-model="stockItem.weight"
                class="form-control"
                id="weight"
                name="weight"
                placeholder="weight in gm"
              />
              <div class="invalid-feedback">Only integers are allowed</div>
            </div>

            <div class="form-group" v-if="BRAND === 'IM'">
              <label for="new_ingredients">New Ingredients</label>
              <treeselect
                :options="ingredients"
                id="new_ingredients"
                label="name"
                v-model="stockItem.new_ingredients"
                multiple
                placeholder="Select your ingredients..."
              />
            </div>

            <div class="form-group">
              <label for="cost">Cost</label>
              <input
                :class="{
                  'is-invalid': $v.stockItem.cost.$invalid && submit,
                  'is-valid': !$v.stockItem.cost.$invalid && submit
                }"
                type="text"
                v-model="stockItem.cost"
                class="form-control"
                id="cost"
                name="cost"
                placeholder="cost i.e: 2.5"
              />
              <div class="invalid-feedback">Only numbers are allowed</div>
            </div>

            <div class="form-group">
              <label for="labels">PDF to Override Label</label>
              <div>
                <input type="file" @change="onFileUpload" ref="file"
                   id="labels" accept="application/pdf" />
              </div>
              <div v-if="uploadState.editUpload">
                <button class="btn btn-link" type="button">
                  <a :href="`${APIURL}files/${uploadState.editUpload}`" target="_blank">Download</a>
                </button>
                <button class="btn btn-link" @click="onFileRemove" type="button">
                  <span class="text-danger">Remove</span>
                </button>
              </div>
            </div>

            <b-btn variant="success" size="md" class="float-left" type="submit"
            >Update
            </b-btn
            >
            <b-btn
              variant="secondary"
              size="md"
              class="float-right"
              :to="'/stock/'"
            >Cancel
            </b-btn
            >
            <br />
            <br />
            <br />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { decimal, integer, numeric, required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import format from "date-fns/format";
import axios from "axios";
import Treeselect from "@riophae/vue-treeselect";
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: "opencart-stock-edit",
  components: {
    DatePicker,
    Treeselect
  },
  mounted() {
    this.getStockItem();

    if ( this.BRAND === 'IM' ) {
        this.getIngredients();
    }
  },
  data() {
    return {
      stockItem: {
        model: "",
        qty: "",
        productName: "",
        ingredients: "",
        new_ingredients: [],
        stockable: "yes",
        supplier_problem: "no",
        expiryDate: null,
        weight: null,
        cost: null,
          normalizer(node) {
              return {
                  id: node.name,
                  label: node.name,
              };
          },

      },
      uploadState: {
        file: null,
        remove: 0,
        editUpload: null,
      },
      submit: false,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Stock", to: { name: "stock" } },
        { text: "Edit", active: true }
      ],
      ingredients: []
    };
  },
  validations() {
    return {
      stockItem: {
        expiryDate: {},
        model: {
          required
        },
        qty: {
          required,
          numeric
        },
        productName: {
          required
        },
        ingredients: {
          required
        },
        stockable: {
          required
        },
        supplier_problem: {
          required
        },
        weight: {
          integer
        },
        cost: {
          decimal
        },
        new_ingredients: ( this.BRAND === "IM" ) ? {
          required
        } : {},
      }
    };
  },
  methods: {
    setExpiryDate(e) {
      this.stockItem.expiryDate = e ? format(e, "yyyy-MM") : null;
    },
    getStockItem() {
      let loader = this.$loading.show();
      this.$http
      .get(
        this.APIURL + this.BRAND + "/stock/" + this.$route.params.id + "/edit"
      )
      .then(
        response => {
          this.stockItem.model = response.data.model;
          this.stockItem.qty = response.data.quantity;
          this.stockItem.productName = response.data.name;
          this.stockItem.ingredients = response.data.ingredients;
          this.stockItem.stockable = response.data.stockable;
          this.stockItem.supplier_problem = response.data.supplier_problem;
          this.stockItem.expiryDate = response.data.expiry_date;
          this.stockItem.weight = response.data.weight;
          this.stockItem.cost = response.data.cost;
          this.uploadState.editUpload = response.data.override_label;
          this.stockItem.new_ingredients = response.data.new_ingredients ? response.data.new_ingredients.map((i) => i.ingredient_id) : [];
          loader.hide();
        },
        error => {
          console.log(error);
        }
      );
    },
    updateStock() {
      this.submit = true;

      if ( !this.$v.stockItem.$invalid ) {
        //show loader
        let loader = this.$loading.show();
        let formData = new FormData();
        formData.append('model', this.stockItem.model);
        formData.append('qty', this.stockItem.qty);
        formData.append('name', this.stockItem.productName);
        formData.append('ingredients', this.stockItem.ingredients);
        formData.append('stockable', this.stockItem.stockable);
        formData.append('supplier_problem', this.stockItem.supplier_problem);
        formData.append('expiryDate', this.stockItem.expiryDate);
        formData.append('weight', this.stockItem.weight);
        formData.append('cost', this.stockItem.cost);
        formData.append('upload', this.uploadState.file);
        formData.append('remove', this.uploadState.remove);

        if ( this.stockItem.new_ingredients ) {
          this.stockItem.new_ingredients.map((item, index) => formData.append(`new_ingredients[${ index }]`, item));
        }

        const headers = { 'Content-Type': 'multipart/form-data' };

        axios
        .post(this.APIURL + this.BRAND + "/stock/" + this.$route.params.id +"/update", formData, { headers })
        .then(
          () => {
            this.$swal({
              title: "Success!",
              showConfirmButton: false,
              timer: 1000,
              html:
                "Operation completed successfully, taking you back to product list.",
              type: "success",
              onClose: () => {
                loader.hide();
                this.$router.push({ name: "stock" });
              }
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    },
    onFileUpload() {
      this.uploadState.file = this.$refs.file.files[0];
    },
    onFileRemove() {
      this.uploadState.file = null;
      this.uploadState.editUpload = null;
      this.uploadState.remove = 1;
    },
    getIngredients() {
      let loader = this.$loading.show();
      this.$http
      .get(
        this.APIURL + this.BRAND + "/ingredients"
      )
      .then(
        response => {
          this.ingredients = response.data.ingredients.map(item => ( { id: item.ingredient_id, label: item.name } ));
          loader.hide();
        },
        error => {
          console.log(error);
        }
      );
    },
  }
};
</script>
